<!-- eslint-disable vue/multi-word-component-names -->

<template>
    <section v-if="data" class="relative">
      <img :src="data.imagenUrl" alt="Banner" class="w-full h-64 object-cover brightness-75">
      <div class="absolute inset-0 flex items-center justify-center">
        <h2 class="text-white text-3xl md:text-5xl font-bold drop-shadow-lg">{{ data.titulo }}</h2>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { doc, getDoc } from 'firebase/firestore'
  import { db } from '@/firebase'
  
  const data = ref(null)
  
  onMounted(async () => {
    const snap = await getDoc(doc(db, 'promociones', 'landingBanner'))
    if (snap.exists()) data.value = snap.data()
  })
  </script>
  